import { Rng } from '../../shared';
import { CARD_POOL, type CardDef } from '../../content/cards/catalog';

export const OPPONENT_STYLES = ['company', 'raiders', 'archive', 'procession'] as const;
export type OpponentStyle = typeof OPPONENT_STYLES[number];
export interface Opponent { style: OpponentStyle; families: CardDef['family'][]; power: number }

/** Twelve unique cards, no bonus stats. Composition is fixed; species and deal are seeded.
 * Printed strength stays within 36–39 (the player's starter deck has 39).
 * The rotating schedule guarantees four different approaches in four matches.
 */
export function opponentDeck(seed: string, index: number): { opponent: Opponent; deck: string[] } {
  const schedule = new Rng(seed).stream('card-table:styles').shuffle([...OPPONENT_STYLES]);
  const style = schedule[((index % 4) + 4) % 4];
  const families = new Rng(seed).stream('card-table:species', index).shuffle(['cat', 'hare', 'snail', 'goose'] as CardDef['family'][]);
  const recipes: Record<OpponentStyle, number[][]> = {
    company: [[0, 1, 2, 3], [0, 1, 2, 3], [0, 1, 2, 3], []],
    raiders: [[0, 2, 3, 4], [0, 2, 3, 4], [0, 2], [2, 3]],
    archive: [[0, 2, 3, 4], [0, 2, 4], [0, 2, 4], [1, 3]],
    procession: [[0, 2, 5], [0, 2, 5], [1, 2, 3], [1, 2, 3]],
  };
  const deck = recipes[style].flatMap((roles, f) => roles.map(role => `${families[f]}_${role}`));
  const power = deck.reduce((sum, id) => sum + CARD_POOL.find(c => c.id === id)!.power, 0);
  return { opponent: { style, families: families.filter((_, f) => recipes[style][f].length > 0), power }, deck };
}
